<template>
  <div class="common-container">
    <div class="tabs-container">
      <el-tabs class="tabs-area sp" @tab-click="categoryClick">
        <el-tab-pane
          v-for="item in btnList"
          :key="item.categoryCode"
          :label="item.label"
          :name="item.categoryCode"
        ></el-tab-pane>
      </el-tabs>
    </div>
    <div>
      <!-- <div v-if="btnList.length">
        <el-scrollbar v-show="saleActive === '0'" ref="scrollbar" :horizontal="true" wrap-class="scroll-wrapper">
          <div ref="btnContent" class="btn-content">
            <div
              v-for="(item, index) in btnList"
              :key="item.categoryCode"
              class="btn-item"
              :class="{ active: index === currentIndex }"
              @click="categoryClick(item, index)"
            >
              {{ item.label }}
            </div>
          </div>
        </el-scrollbar>
      </div> -->

      <div class="product">
        <el-carousel
          v-if="dataList.length > 0"
          :key="saleActive"
          class="content-carousel"
          height="234px"
          :autoplay="defaultProps.autoplay"
        >
          <div v-for="(arr, index) in dataList" :key="index">
            <el-carousel-item>
              <div class="flex">
                <div v-for="(list, index1) in arr" :key="index1" class="product-item">
                  <div class="product-info">
                    <div class="product-info-img">
                      <!-- :src="list.defaultimage" -->
                      <img :src="list.defaultimage" width="160" height="160" />
                      <!-- <img v-lazy="list.defaultimage" width="224" height="224" /> -->
                    </div>
                    <p class="product-info-title">
                      {{ list.skuname }}
                    </p>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </div>
        </el-carousel>
        <div v-else class="empty">
          <img src="@/assets/img/common/icon-empty@2x.png" alt="" width="215" height="174" />
          <p>抱歉，该供应企业还没有发布销售的商品</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/modules/projectA/api/enquiry';

export default {
  props: {
    paneList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      btnShow: false,
      saleActive: '0',
      btnActive: '0',
      currentIndex: 0,
      btnList: [],

      defaultProps: {
        autoplay: false,
      },
      dataList: [],

      isSonstandard: false,
    };
  },
  // queryProductPage
  watch: {
    paneList: {
      async handler(newVal) {
        console.log('paneList', newVal);
        if (newVal.length) {
          this.btnList = newVal.map((item) => ({
            label: item.categoryName,
            categoryCode: item.categoryCode,
          }));

          /* this.$nextTick(() => {
            this.initScrollBtn();
          }); */

          const [{ tableData = [], categoryCode = '-1' }] = newVal;
          this.btnActive = categoryCode;

          if (tableData.length === 0) {
            this.dataList = [];
            return;
          }

          const skuIds = tableData.map((item) => item.skuid);
          const res = await Api.queryProductPage({ skuIds, pageSize: tableData.length || 100 });
          if (res.code === '200') {
            const productList = res.data.list;
            const sortList = [];
            skuIds.forEach((item) => {
              productList.forEach((iten) => {
                if (item === iten.skuid) {
                  sortList.push(iten);
                }
              });
            });
            if (sortList.length > 10) {
              sortList.length = 10;
            }
            const result = [];
            for (let i = 0; i < sortList.length; i += 5) {
              result.push(sortList.slice(i, i + 5));
            }
            this.dataList = [...result];
            console.log(this.dataList, 'this.dataList');
          }
        }
      },
    },
    deep: true,
  },
  methods: {
    initScrollBtn() {
      const container = this.$refs.btnContent;
      const containerW = container.offsetWidth;
      console.log(containerW, 'containerW');
      const itemList = document.querySelectorAll('.btn-item');
      const that = this;
      for (let i = 0; i < itemList.length; i++) {
        itemList[i].onclick = function () {
          console.log(itemList[i].offsetLeft, itemList[i].offsetWidth, containerW);
          const scrollLeftNum = itemList[i].offsetLeft - containerW / 2 + itemList[i].offsetWidth / 2;
          console.log(scrollLeftNum, '距离');
          that.$refs.scrollbar.wrap.scrollTo({
            top: 0,
            left: scrollLeftNum,
            behavior: 'smooth',
          });
        };
      }
    },
    async handleSaleClick(val) {
      this.saleActive = val.name;
      if (val.name !== '0') {
        const { companyId } = this.$store.state.USERINFO;
        const res = await Api.queryProductPage({
          supplierCompanyIds: [companyId],
          pageSize: 10,
          pageNum: 1,
          datafrom: Number(this.saleActive),
        });
        if (res.code === '200') {
          const {
            data: { list },
          } = res;

          if (list.length > 10) {
            list.length = 10;
          }

          const result = [];
          for (let i = 0; i < list.length; i += 5) {
            result.push(list.slice(i, i + 5));
          }

          this.dataList = [...result];
          if (this.dataList.length > 10) {
            this.dataList.length = 10;
          }
        }
      } else {
        this.categoryClick({ categoryCode: this.btnActive }, this.currentIndex);
      }
    },
    handleMouseenter() {
      this.btnShow = true;
    },
    handleMouseleave() {
      this.btnShow = false;
    },
    //
    async categoryClick(val, index) {
      console.log(val, index);
      try {
        this.currentIndex = index;
        this.btnActive = val.name;
        const { tableData = [] } =
          this.paneList.find((item) => {
            return item.categoryCode === val.name;
          }) || {};

        if (tableData.length === 0) {
          this.dataList = [];
          return;
        }
        const skuIds = tableData.map((item) => item.skuid);
        console.log(skuIds, 'skuIds');
        const res = await Api.queryProductPage({ skuIds, pageSize: tableData.length || 100 });
        if (res.code === '200') {
          const productList = res.data.list;
          const sortList = [];
          skuIds.forEach((item) => {
            productList.forEach((iten) => {
              if (item === iten.skuid) {
                sortList.push(iten);
              }
            });
          });
          if (sortList.length > 10) {
            sortList.length = 10;
          }
          const result = [];
          for (let i = 0; i < sortList.length; i += 5) {
            result.push(sortList.slice(i, i + 5));
          }
          this.dataList = [...result];
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.tabs-area {
  ::v-deep .el-tabs__header {
    .el-tabs__item {
      font-size: 14px;
      font-weight: 400;
    }
  }
}

.horizontal-scrollbar {
  height: 100px; /* 设置滚动区域的高度 */
  transition: all 0.2s;
}
.btn-content {
  /* margin-bottom: 10px; */
  margin: 0 20px 10px 0;
  display: flex;
  .btn-item {
    height: 32px;
    padding: 0 10px;
    margin-right: 20px;
    line-height: 32px;
    color: #333;
    cursor: pointer;
    white-space: nowrap;
    &.active {
      background: #e8efff;
      color: #2587ff;
      font-weight: bold;
    }
    &:hover {
      color: #2587ff;
    }
  }
}
.product {
  position: relative;
  &:hover {
    .config {
      display: flex;
    }
  }
  .empty {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 234px;
    p {
      margin-top: 10px;
    }
  }
  .config {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 2;
    width: 100%;
    height: 100%;
    display: none;
    justify-content: center;
    align-items: center;
    background: rgba(0, 0, 0, 0.3);
  }
  .product-item {
    flex: none;
    width: 170px;
    height: 234px;
    background: #fff;
    position: relative;
    border-right: 1px solid #d9d9d9;
    &:last-child {
      border-right: none;
    }
    &:first-child {
      margin-left: -5px;
    }
    .product-info {
      /* padding: 10px; */
      flex: none;
      width: 170px;
      height: 234px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .product-info-img {
        flex: none;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 160px;
        height: 160px;
        margin-bottom: 20px;
        img[lazy='error'] {
          width: 146px !important;
          height: 100px !important;
        }
      }
      .product-info-title {
        width: 160px;
        height: 48px;
        padding: 0 10px;
        display: -webkit-box;
        overflow: hidden;
        white-space: normal !important;
        text-overflow: ellipsis;
        word-wrap: break-word;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        font-size: 16px;
        font-weight: 400;
        color: #333333;
        line-height: 24px;
      }
    }
  }
  .product_item:last-child {
    margin-right: 0;
  }
  .content-carousel ::v-deep .el-carousel__indicators {
    display: none;
  }

  .content-carousel ::v-deep .el-carousel__container {
    .el-carousel__item {
      /* padding: 0 20px; */
    }
    .el-carousel__arrow {
      border-radius: 0 18px 18px 0;
    }
    .el-carousel__arrow--left {
      left: 0;
      width: 33px;
      height: 66px;
      border-radius: 0 33px 33px 0;
      line-height: 66px;
      font-size: 20px;
      background: rgba(51, 51, 51, 0.3);
    }
    .el-carousel__arrow--right {
      /* right: 0;
      width: 24px;
      height: 48px;
      border-radius: 24px 0 0 24px;
      line-height: 48px; */
      right: 0;
      width: 33px;
      height: 66px;
      border-radius: 0 33px 33px 0;
      line-height: 66px;
      font-size: 20px;
      background: rgba(51, 51, 51, 0.3);
    }
  }
}
.tabs-container {
  width: 100%;
  margin: -10px 0 5px 0;
}
::v-deep .el-tabs {
  .el-tabs__active-bar {
    bottom: 1px;
    background: #2587ff;
  }
  .el-tabs__nav-wrap {
    &::after {
      height: 1px;
      background: #d9d9d9;
    }
    .el-tabs__nav {
      /* margin-left: 20px; */
    }
  }
  .el-tabs__item {
    font-size: 18px;
    color: #333;
    &.is-active {
      color: #2587ff;
    }
    &:hover {
      color: #2587ff;
    }
  }
}
::v-deep .sp {
  .el-tabs__nav {
    margin-left: 20px;
  }
}
.common-container {
  min-width: 840px;
  background: #fff;
  .title {
    background: linear-gradient(
      90deg,
      rgba(102, 171, 254, 0.5) 0%,
      rgba(73, 151, 246, 0) 100%,
      rgba(255, 255, 255, 0) 100%
    );
    width: 90px;
    height: 30px;
    font-size: 18px;
    line-height: 28px;
    padding-left: 10px;
    margin-bottom: 18px;
    span {
      line-height: 1;
      font-weight: 500;
    }
  }
  .content {
    overflow: hidden;
  }
}
</style>
